<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-indent:0em">When I was a small child, I visited my father’s fields and harvested some of his rich, black loam. This I took home and moistened with water from the front yard pump. Out of this concoction, I created various flat animal forms: a cow, a duck, a rabbit, a chicken, a pig. The same force that drove me to do that thing then remains with me today, allowing me to cast years of observation and experience into animals of a more permanent form. For this, I give thanks.</p><br/>
<p style="text-indent:0em">I also thank Bob and Anita Damon, who photographed my portrait for this work.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?947d6542